export default "__VITE_ASSET__CGMZ_Yvu__"